import axios from "axios"

let lastSignature = ""
let lastReportedAt = 0

const textOf = (value) => {
  if (value == null) return ""
  if (value instanceof Error) return value.message || value.name || "Error"
  if (typeof value === "string") return value
  try { return JSON.stringify(value) } catch (e) { return String(value) }
}

const stackOf = (value) => {
  if (value && value.stack) return String(value.stack)
  return textOf(value)
}

const currentLogin = () => {
  try { return JSON.parse(localStorage.getItem("userInfo") || "null") || {} }
  catch (e) { return {} }
}

export const reportWebError = (data = {}) => {
  const login = currentLogin()
  const user = login.user || {}
  const payload = {
    source: data.source || "WEB",
    level: data.level || "ERROR",
    message: textOf(data.message) || "未知页面错误",
    detail: textOf(data.detail),
    url: data.url || window.location.href,
    route: data.route || `${window.location.pathname}${window.location.hash}`,
    method: data.method || "",
    status: data.status == null ? null : Number(data.status),
    userAgent: navigator.userAgent,
    userName: user.userName || ""
  }
  const signature = `${payload.source}|${payload.message}|${payload.url}`
  const now = Date.now()
  if (signature === lastSignature && now - lastReportedAt < 3000) return
  lastSignature = signature
  lastReportedAt = now
  const headers = login.token ? { Authorization: login.token } : {}
  axios.post("/api/web-log/report", payload, { headers, timeout: 3000 }).catch(() => {})
}

export const installWebErrorLogger = (app, ElMessage) => {
  app.config.errorHandler = (error, instance, info) => {
    reportWebError({
      source: "WEB",
      message: textOf(error),
      detail: `${info || "Vue error"}\n${stackOf(error)}`
    })
  }

  window.addEventListener("error", event => {
    reportWebError({
      source: "WEB",
      message: event.message || textOf(event.error),
      detail: stackOf(event.error),
      url: event.filename || window.location.href
    })
  })

  window.addEventListener("unhandledrejection", event => {
    reportWebError({
      source: "WEB",
      message: textOf(event.reason) || "未处理的 Promise 异常",
      detail: stackOf(event.reason)
    })
  })

  // 统一取消既有错误气泡；原有 ElMessage.error 调用改为静默写入服务器日志。
  if (ElMessage && typeof ElMessage.error === "function") {
    ElMessage.error = message => {
      reportWebError({ source: "WEB", message: textOf(message) })
      return { close: () => {} }
    }
  }
}
